var exports = {
  "k": "xa15a2ab7--c0250f--container",
};

module.exports = exports;
